import { push } from 'react-router-redux';
import { createActions } from 'redux-actions';
import { put, select } from 'redux-saga/effects';
import { apiActionResult } from "../../common";
import { authTokenSelector } from '../../session';
import { apiAction as addAfsLicenceApiAction, default as addAfsLicenceConfig } from './addAfsLicence';

const actions = createActions({
  USER: {
    ADD_AFSL: (afsLicence, nextUrl) => ({ afsLicence, nextUrl })
  }
})

/**
 * This is specifically used for on-boarding process of AFS Licence number acquisition.
 * After updating the user, perform navigation to next step of on-boarding (areas of advice).
 */
export function* addAfsl({
  payload: {
    afsLicence,
    nextUrl
  }
}) {
  const authToken = yield select(authTokenSelector);

  yield put(addAfsLicenceApiAction(authToken, afsLicence));

  const afsLicenceResult = yield apiActionResult(addAfsLicenceConfig.action.user.api.addAfsLicence);

  if (afsLicenceResult.success && !afsLicence.noRedirect) {
    yield put(push({ pathname: nextUrl }));
  }
}

const configuration = {
  name: 'addAfsl',
  action: actions,
  sagas: addAfsl,
  reducers: {

  }
}

export default configuration;


// WEBPACK FOOTER //
// ./src/state/modules/user/configurations/addAfsl.js